import { attachmentService } from '@/services'

const images = [
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/defaultImages/logo-1.png',
    name: 'first.png',
    type: 'image/png'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/defaultImages/logo-2.png',
    name: 'second.png',
    type: 'image/png'
  }
]

export default async ({ dispatch, commit, bookId }) => {
  const discussion = await dispatch('createDiscussion', {
    title: 'Which of the two should become our new logo?',
    bookId: bookId
  })

  const uploadedImages = {}

  for (const image of images) {
    commit('loading', true)

    const { data } = await attachmentService.proxy(image.url)

    const file = new File([data], image.name, { type: image.type })

    const formData = new FormData()
    formData.append('data', file, image.name)

    commit('loading', true)

    const response = await attachmentService.upload({
      discussionId: discussion.data.id,
      data: formData
    })

    uploadedImages[image.name] = {
      id: response.data.id,
      url: response.data.url
    }
  }

  const content = `
    <p>Hi everyone,</p>
    <p></p>
    <p>As you all know, we're working on a new company logo (the current one is not so <em>popular</em>, and that's an understatement). We reviewed at least 50 logo designs in the past 4 weeks. We now narrowed them down to the two best designs. To make the final decision we would like to ask you guys for help. </p>
    <p></p>
    <p>Which one should become our new logo?</p>
    <p></p>
    <p><span type="image"
      src="${uploadedImages['first.png']?.url}"  id="${uploadedImages['first.png']?.id}"
      style="width: 33%; position: relative; display: inline-block;n line-height: 0; vertical-align:
      text-bottom; max-width: 98%; min-width: 100px" class="0" ischateditor="false" contenteditable="false"><span
        contenteditable="false"></span><span contenteditable="false"></span><span
        contenteditable="false"></span><img
        src="${uploadedImages['first.png']?.url}"  id="${uploadedImages['first.png']?.id}"
        style="width: 33%; position: relative; display: inline-block;n line-height: 0; vertical-align:
        text-bottom; max-width: 98%; min-width: 100px" class="0" ischateditor="false"></span> <span type="image"
      src="${uploadedImages['second.png']?.url}"  id="${uploadedImages['second.png']?.id}"
      style="width: 35%; position: relative; display: inline-block;n line-height: 0; vertical-align:
      text-bottom; max-width: 98%; min-width: 100px" class="0" ischateditor="false" contenteditable="false"><span
        contenteditable="false"></span><span contenteditable="false"></span><span
        contenteditable="false"></span><img
        src="${uploadedImages['second.png']?.url}"  id="${uploadedImages['second.png']?.id}"
        style="width: 35%; position: relative; display: inline-block;n line-height: 0; vertical-align:
        text-bottom; max-width: 98%; min-width: 100px" class="0" ischateditor="false"></span></p>
    <p></p>
    <p></p>
    <p>Let me know what you guys think. :)</p>
    <p></p>
    <p>Cheers,</p>
    <p>Bob</p>
  `
  await dispatch('postDiscussion', {
    id: discussion.data.id,
    bookId
  })

  await dispatch('updateDiscussion', {
    id: discussion.data.id,
    content,
    bookId,
    newBookId: bookId
  })
}
